import React, { useEffect, useState } from "react";

type DisplayFileSizeProps = {
  file: File | string;
};

const formatFileSize = (bytes: number) => {
  if (bytes === 0) {
    return "0 bytes";
  }

  const k = 1024;
  const sizes = ["bytes", "KB", "MB", "GB", "TB"];
  const sizeIndex = Math.floor(Math.log(bytes) / Math.log(k));
  const divisor = k ** sizeIndex;
  const value = (bytes / divisor).toFixed(1);

  return `${Number.parseFloat(value)} ${sizes[sizeIndex]}`;
};

const DisplayFileSize = (props: DisplayFileSizeProps) => {
  const [fileSize, setFileSize] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchFileSize = async () => {
      try {
        setIsLoading(true);

        if (props.file instanceof File) {
          setFileSize(props.file.size);

          return;
        }

        const response = await fetch(props.file);
        const blob = await response.blob();

        setFileSize(blob.size);
      } catch (error) {
        console.error("Error fetching file size:", error);

        setFileSize(null);
      } finally {
        setIsLoading(false);
      }
    };

    if (props.file) {
      void fetchFileSize();
    } else {
      setFileSize(null);
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    return <div className="file-size">ขนาด -</div>;
  }

  if (fileSize === null) {
    return null;
  }

  return <div className="file-size">ขนาด {formatFileSize(fileSize)}</div>;
};

export default DisplayFileSize;
